<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import PartnerLogoIcon from '@/assets/icons/partner-logo.svg'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'

const router = useRouter()
const props = defineProps({
  partnerName: String,
  partnerId: Number,
  openNewTab: { type: Boolean, default: true },
  params: Object,
})

const name = computed(() => props.params?.data?.resName || props.partnerName)
const id = computed(() => props.params?.data?.resId || props.partnerId)

const navigateToPartner = () => {
  const route = `/partner/${id.value}`

  if (props.openNewTab) {
    window.open(route, '_blank', 'noopener,noreferrer')
  } else {
    router.push(route)
  }
}
</script>

<template>
  <div class="tooltip tooltip-top" :data-tip="name">
    <ButtonDaisy
      @click="navigateToPartner"
      type="button"
      :text="name"
      :icon="PartnerLogoIcon as Object"
    />
  </div>
</template>
